<template>
  <div class="page-loading" v-if="isLoading">
    <font-awesome-icon :icon="['fad', 'spinner-third']" spin />
  </div>
  <div class="container-fluid">
    <header class="main-header">
      <h1 class="main-title">Vrije dagen</h1>
    </header>

    <form @submit.prevent="formSubmit">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-10 col-xl-8">
        <div class="card gebruikers-beheer">
          <div class="card-body">
            <h5>Jaartal</h5>
            <div class="form-group">
              <div class="input-group">
                <select class="form-select year-select" v-model="selectedYear" @change="getHolidays">
                  <option disabled selected value="">Kies een jaartal</option>
                  <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                </select>
              </div>
            </div>
            <ul class="list-group" v-if="selectedYear">
              <li class="list-group-item list-group-item-disabled">
                <div class="col">Feestdag</div>
                <div class="col">Datum</div>
                <div class="col">Vrije dag</div>
              </li>
              <li class="list-group-item" v-for="day in sortedFreeDays" :key="day.id">
                <div class="col">{{ day.name }}</div>
                <div class="col">{{ formatDate(day.date) }}</div>
                <div class="col">
                  <input type="checkbox" class="form-check-input secondary-checkbox" v-model="day.freeDay"
                    @change="updateFreeDay(day)" />
                </div>
              </li>
            </ul>
            <router-link to="/vrijedagen/toevoegen" class="text-secondary text-decoration-none mt-2 d-block">Vrije dag
              toevoegen</router-link>
          </div>
        </div>
        <div class="actions">
          <button type="button" @click="getHolidays()" class="btn btn-gray">Annuleren</button>
          <button type="submit" @click="updateHolidays()" class="btn btn-primary-dark ms-3">Opslaan</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'FreeDays',
  data() {
    return {
      isLoading: false,
      selectedYear: new Date().getFullYear(),
      years: [],
      freeDays: [],
    };
  },
  computed: {
    sortedFreeDays() {
      return this.freeDays.slice().sort((a, b) => new Date(a.date) - new Date(b.date));
    }
  },
  methods: {
    getHolidays() {
      if (this.selectedYear) {
        this.isLoading = true;
        this.$axiosInstance.get(`${process.env.VUE_APP_API}/Holidays`, {
          params: { year: this.selectedYear }
        })
          .then(response => {
            if (response.data && response.data.length > 0) {
              this.freeDays = response.data.map(day => ({
                ...day,
                date: new Date(day.date)
              }));
            } else {
              this.createHolidays();
            }
          })
          .catch(() => {
            this.$toast.open({
              message: 'Feestdagen konden niet opgehaald worden. Probeer het a.u.b. opnieuw.',
              type: 'error',
              position: 'top-right',
              duration: 5000
            });
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    createHolidays() {
      this.$axiosInstance.post(`${process.env.VUE_APP_API}/Holidays/create-default`, { year: this.selectedYear })
        .then(postResponse => {
          if (postResponse.status === 200) {
            this.getHolidays();
          }
        })
        .catch(() => {
          this.$toast.open({
            message: 'Feestdagen konden niet aangemaakt worden. Probeer het a.u.b. opnieuw.',
            type: 'error',
            position: 'top-right',
            duration: 5000
          });
        });
    },
    updateHolidays() {
      this.isLoading = true;
      this.$axiosInstance.put(`${process.env.VUE_APP_API}/Holidays`, { holidays: this.freeDays })
        .then(() => {
          this.$toast.open({
            message: 'Vrije dagen zijn succesvol opgeslagen.',
            type: 'success',
            position: 'top-right',
            duration: 5000
          });
        })
        .catch(() => {
          this.$toast.open({
            message: 'Vrije dagen konden niet opgeslagen worden. Probeer het a.u.b. opnieuw.',
            type: 'error',
            position: 'top-right',
            duration: 5000
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('nl-NL', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });
    },
    updateFreeDay(day) {
      const holiday = this.freeDays.find(d => d.name === day.name);
      if (holiday) {
        holiday.freeDay = day.freeDay;
      }
    },
  },
  mounted() {
    this.getHolidays();
    this.years = [this.selectedYear - 1, this.selectedYear, this.selectedYear + 1, this.selectedYear + 2];
  },
};
</script>

<style lang="scss" scoped>
.list-group {
  .list-group-item {
    display: flex;
    align-items: center;

    .col {
      flex: 1;
    }

    .form-select {
      max-width: 10rem;
      margin-left: auto;
      border: 0;
      border-radius: 0;
    }
  }

  .list-group-item-disabled {
    background-color: #e9ecef;
    font-weight: bold;

    .form-select {
      background-color: #e9ecef;
    }
  }
}

.actions {
  margin-top: $spacer * 1.5;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .btn {
    min-width: 7.5rem;
  }
}
</style>